import { Typography, Link } from "@material-ui/core";


const Footer = () => (
  <Typography>This free website was provided by Hearth. Learn more at <Link href="https://www.gethearth.com/" target="_blank">GetHearth.com</Link>.</Typography>
)

export default Footer;